export default {
  install(Vue) {
    Vue.prototype.$log = {
      pageView: params => {
        if (typeof window !== 'undefined' && window.Log) {
          window.Log.pageView(params)
        }
      },
      click: params => {
        if (typeof window !== 'undefined' && window.Log) {
          window.Log.click(params)
        }
      },
      setDebug: () => {
        if (typeof window !== 'undefined' && window.Log) {
          window.Log.setDebug()
          console.warn('打点日志已经开启debug模式，生产环境下务必关闭！')
        }
      }
    }
  }
}
